export const memzero = (value: Uint8Array): Uint8Array => value.fill(0, 0, value.length);
